<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="header">
      <div class="title">新型农村集体经济组织订单</div>
    </div>
    <div class="closeBtn" @click="close"></div>
    <div class="dialog-body">
      <div class="map">
        <Map ref="Map" @area-click="handleAreaClick" />
      </div>
      <dv-decoration-12
        :scan-dur="4"
        :halo-dur="3"
        :color="['#5bc0f8', 'transparent']"
      ></dv-decoration-12>
      <MapTable ref="MapTable" @change="handleTableChange" />
    </div>
  </div>
</template>
<script>
import Map from '../components/Map'
import MapTable from '../components/MapTable'
export default {
  name: 'AreaCompanyMapDialog',
  components: { Map, MapTable },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleAreaClick(area) {
      const mapTable = this.$refs.MapTable
      if (!mapTable || !mapTable.areaList || mapTable.areaList.length === 0) return
      const index = mapTable.areaList.findIndex(item => item.districtCode === area.areaCode)
      if (index !== -1) {
        mapTable.setActiveIndex(index)
      }
    },
    handleTableChange(item) {
      const map = this.$refs.Map
      if (map && item && item.districtCode) {
        map.setSelectedArea(item.districtCode)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  // width: 3136px !important;
  height: 1900px !important;
  background: url('~@/img/agriculture/product_bg.png');
  background-size: 100% 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: none;

  .header {
    display: flex;
    align-items: center;
    padding: 30px 0 0 60px;

    .title {
      font-size: 48px;
      color: #ffffff;
      font-weight: 500;
    }
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/agriculture/close_btn.png');
    background-size: 100% 100%;
  }

  .dialog-body {
    position: relative;
    padding: 100px 60px 0;
    height: calc(100% - 100px);

    .map {
      margin-top: 150px;
      height: 1100px;
      text-align: center;
      position: relative;
      background: url('~@/img/agriculture/map_bg.png') no-repeat center -75px;

      .map-container {
        position: relative;
        z-index: 7777;
      }
    }
  }

  .dv-decoration-12 {
    z-index: -99;
    position: absolute;
    left: 50%;
    top: 56%;
    transform: translate(-50%, -50%);
    width: 1200px;
    height: 1200px;
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: translate(-50%, -50%) scale(0);
    }

    100% {
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
